const ReportsDashboard = () => {
    return <div>ReportsDashboard Content</div>;
  };
  
  export default ReportsDashboard;